import { render, staticRenderFns } from "./InvoiceDataTable.vue?vue&type=template&id=4efbbf89&"
import script from "./InvoiceDataTable.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports